import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchCategoryImages, fetchHeroSlides } from "@/lib/api";

const SITE_STALE_TIME = 5 * 60_000;
const SITE_GC_TIME = 30 * 60_000;

export const HERO_SLIDES_QUERY_KEY = ["site", "hero"] as const;
export const CATEGORY_IMAGES_QUERY_KEY = ["categories"] as const;

export function useHeroSlides() {
  return useQuery({
    queryKey: HERO_SLIDES_QUERY_KEY,
    queryFn: fetchHeroSlides,
    staleTime: SITE_STALE_TIME,
    gcTime: SITE_GC_TIME,
    retry: 1,
  });
}

export function useCategoryImages() {
  return useQuery({
    queryKey: CATEGORY_IMAGES_QUERY_KEY,
    queryFn: fetchCategoryImages,
    staleTime: SITE_STALE_TIME,
    gcTime: SITE_GC_TIME,
    retry: 1,
  });
}

export function useInvalidateSiteContent() {
  const queryClient = useQueryClient();

  return {
    invalidateHero: () => queryClient.invalidateQueries({ queryKey: HERO_SLIDES_QUERY_KEY }),
    invalidateCategories: () => queryClient.invalidateQueries({ queryKey: CATEGORY_IMAGES_QUERY_KEY }),
  };
}
